import apiCall from "../../../axios/apiCall"; 
import { PREFIX_API } from "../shared/constants";

const controller = `${PREFIX_API}/usuarios`;
export default { 
  getUsers: async (FiltersUser) => {
    let response = { success: true }; 
    const method = `consultar`;
    try {
      const apiResponse = await apiCall.post(controller, method, FiltersUser);
      response.data = apiResponse?.data;
    } catch (error) {
      response = apiCall.handleCatch(error);
    }
    return response;
  },
  createUser: async (values) => {
    let response = { success: true };
    const method = ``; 
    try {
      const apiResponse = await apiCall.post(controller, method, values);
      response.message = apiResponse?.data?.mensaje;
    } catch (error) {
      response = apiCall.handleCatch(error);
    }
    return response;
  },
  updateUser: async (values) => {
    let response = { success: true };
    const method = ``;
    try {
      const apiResponse = await apiCall.put(controller, method, values);
      response.message = apiResponse?.data?.mensaje;
    } catch (error) {
      response = apiCall.handleCatch(error);
    }
    return response;
  },
};
